/* DOMNO. — shared helpers for the rewards portal. Load this BEFORE anything else.

   ============================ dpMoney ============================
   ⚠ On domno.com the Liquid money filter emits <span class="money">£35.00</span>, not £35.00.
   This has bitten twice, most recently reaching Dom as
       ESSENTIAL RING · 8 IS IN YOUR BAG — WORTH <SPAN CLASS=MONEY>£35.00</SPAN>
   The drawer is Charlie's 30KB file and a rewrite to add one filter is the riskier fix, so the
   stripping happens here, on the way in AND on the way out.
   ANYTHING that renders a Liquid price string must go through dpMoney() first.

   ==================== dpMinSpendValue / dpMinSpend ====================
   ⚠ THE THRESHOLD IS ENFORCED IN POUNDS, ON CONVERTED MONEY — not on the catalogue price.
   The worker checks `currentSubtotalPriceSet.shopMoney` against 25, and shopMoney is the
   presentment total converted at the live FX rate. Proved on order D86356: $70.00 presented,
   £51.69 shopMoney — a ratio of 1.354, the USD rate of the day, not the 1.75x that DOMNO.'s US
   price list uses. So the local threshold is 25 x Shopify.currency.rate.
   dpMinSpendValue returns the NUMBER and dpMinSpend the string, and the £25 guard and the copy
   both read the same one — so what a customer is told can never differ from what is enforced.

   ⚠ Decimals are adaptive on purpose. Rounding everything to whole units reported a £3.99 basket
   back as "you're at £4", and someone at £24.50 would have been told they were at £25 *while
   being blocked*. Whole amounts print whole, pennies print pennies.

   ============================ dpCartQueue ============================
   ⚠ ONE CART MUTATION AT A TIME. THIS FIXES A REAL BUG.
   Dom, 9 Sep: "occasionally, when I'd pick a free item, remove it, then pick another free item,
   it wouldn't show in the cart." Reproducing the raw HTTP sequence 24 times found nothing wrong
   with the calls themselves — the fault is two of OUR OWN functions overlapping.

   `dpRemoveGift()` reads the cart, then deletes every reward line it found. `pick()` reads the
   cart, deletes, then adds. Run them close together and dpRemoveGift's READ can land AFTER
   pick's ADD — so it dutifully deletes the piece that was just chosen, and the cart ends up
   empty. Which is exactly what Dom saw.

   Every cart write now goes through this queue, so a pick's remove-then-add is atomic with
   respect to a remove, and the two can never interleave. A rejection does not stall the chain. */

window.dpMoney = function (s) {
  if (s == null) return '';
  var str = String(s);
  if (str.indexOf('<') === -1) return str.trim();
  try {
    var d = document.createElement('div');
    d.innerHTML = str;
    return (d.textContent || d.innerText || '').trim();
  } catch (e) {
    return str.replace(/<[^>]*>/g, '').trim();
  }
};

window.dpCurrency = function () {
  try {
    var c = window.Shopify && window.Shopify.currency;
    if (c && c.active) return { code: c.active, rate: parseFloat(c.rate) || 1 };
  } catch (e) {}
  return null;
};

window.dpMinSpendValue = function (gbp) {
  var base = Number(gbp) > 0 ? Number(gbp) : 25;
  var cur = window.dpCurrency();
  if (!cur) return null;
  var v = base * cur.rate;
  var step = v < 100 ? 5 : (v < 1000 ? 10 : (v < 10000 ? 100 : 1000));
  return Math.ceil(v / step) * step;
};

window.dpFormat = function (amount) {
  var cur = window.dpCurrency();
  var n = Math.max(0, Number(amount) || 0);
  var dp = (Math.abs(Math.round(n * 100) % 100) < 1) ? 0 : 2;
  if (!cur) return '£' + n.toFixed(dp);
  try {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
      style: 'currency', currency: cur.code,
      minimumFractionDigits: dp, maximumFractionDigits: dp
    }).format(n);
  } catch (e) {
    return cur.code + ' ' + n.toFixed(dp);
  }
};

/* ============================ dpWorthFor ============================
   🔴 14 Sep 2026 — "WORTH £35.00" STAYED IN POUNDS AFTER SWITCHING TO EUROS. Charlie, testing.
   Every other price on the page changed and this one did not.

   WHY. `_reward_worth` is a line item property, and a line item property is a FROZEN STRING. It
   is written once, at the moment they pick, from Liquid's `product.price | money` — correct for
   the market they were in THEN. Switch market afterwards and the cart line still carries the old
   text. Nothing rewrites a property on a market change, and nothing ever will.

   WHY NOT JUST CONVERT IT. Because DOMNO. sets FIXED prices per market rather than converting —
   in USD a £16 chain and a £20 chain are both $35. Multiplying the stored pounds by
   Shopify.currency.rate would produce a number that is in the right currency and the wrong
   amount, which is worse than the bug: the customer would be quoted a price that exists nowhere.

   WHAT THIS DOES INSTEAD. `#dp-ladder` is re-rendered by Liquid on every page load, in whatever
   market the visitor is in right now, and it carries every variant id with its price. So the
   worth is looked up live from that, by variant id, and the frozen property is only a fallback.

   IF THE LOOKUP FAILS (the piece sold out and dropped out of the ladder data, or the ladder is
   not on this page) the frozen string is used ONLY when the presentment rate is 1, i.e. they are
   in the shop's own currency and it cannot be stale. Otherwise it returns EMPTY and the caller
   simply does not print a worth. Saying nothing is honest; saying £35.00 to someone shopping in
   euros is not. */
window.dpWorthFor = function (variantId, fallback) {
  var id = String(variantId == null ? '' : variantId).replace(/[^0-9]/g, '');
  if (id) {
    var el = document.getElementById('dp-ladder');
    if (el) {
      var keys = ['rings', 'chains', 'pendants', 'any'];
      for (var k = 0; k < keys.length; k++) {
        var arr = [];
        try { arr = JSON.parse(el.getAttribute('data-' + keys[k]) || '[]'); } catch (e) { arr = []; }
        for (var i = 0; i < arr.length; i++) {
          var vs = arr[i] && arr[i][5] ? arr[i][5] : [];
          for (var v = 0; v < vs.length; v++) {
            if (String(vs[v][0]) === id) return window.dpMoney(arr[i][1]);
          }
        }
      }
    }
  }
  var cur = window.dpCurrency();
  if (!cur || cur.rate === 1) return window.dpMoney(fallback);
  return '';
};

window.dpMinSpend = function (gbp) {
  var v = window.dpMinSpendValue(gbp);
  if (v == null) {
    var holder = document.getElementById('dp-rings');
    var fallback = holder && holder.getAttribute('data-minspend');
    return window.dpMoney(fallback || ('£' + (Number(gbp) > 0 ? Number(gbp) : 25)));
  }
  return window.dpFormat(v);
};

(function(){
  var chain = Promise.resolve();
  window.dpCartQueue = function (task) {
    var run = function(){ try { return Promise.resolve(task()); } catch (e) { return Promise.resolve(null); } };
    var next = chain.then(run, run);
    chain = next.catch(function(){});   /* a failure must never stall the queue */
    return next;
  };
})();